// Yofis — контракт API `yofis.v1`. Ссылки-права (ADR-007): инвайты, гости, комнаты, файлы, лобби.
//
// «Кто угодно с токеном может X до T»: токен случайный (base64url, 32 байта), срок, лимит
// использований, лобби, отзыв. Веб-клиент в лёгком режиме — `GET /join/<link_token>`; deep link — `yofis://join/<token>`.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=ts"
// @generated from file yofis/v1/link.proto (package yofis.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Room } from "./call_pb.ts";
import { file_yofis_v1_call } from "./call_pb.ts";
import type { Chat } from "./chat_pb.ts";
import { file_yofis_v1_chat } from "./chat_pb.ts";
import type { PageInfo, User } from "./common_pb.ts";
import { file_yofis_v1_common } from "./common_pb.ts";
import type { ErrorReason } from "./errors_pb.ts";
import { file_yofis_v1_errors } from "./errors_pb.ts";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yofis/v1/link.proto.
 */
export const file_yofis_v1_link: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_yofis_v1_call, file_yofis_v1_chat, file_yofis_v1_common, file_yofis_v1_errors]);

/**
 * Ссылка-право.
 *
 * @generated from message yofis.v1.Link
 */
export type Link = Message<"yofis.v1.Link"> & {
  /**
   * Токен (base64url, 32 байта) — сам по себе является правом; не логировать.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * Полная ссылка для отправки: `https://<host>/join/<token>`.
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * Область действия.
   *
   * @generated from field: yofis.v1.LinkScope scope = 3;
   */
  scope: LinkScope;

  /**
   * Цель: идентификатор чата, комнаты, файла; для USER_INVITE и PASSWORD_RESET — пусто.
   *
   * @generated from field: string target_id = 4;
   */
  targetId: string;

  /**
   * Кто выпустил.
   *
   * @generated from field: string issued_by = 5;
   */
  issuedBy: string;

  /**
   * Когда выпущена.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Срок действия; пусто — бессрочная (только для USER_INVITE по политике узла).
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 7;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * Лимит использований; 0 — без лимита.
   *
   * @generated from field: int32 max_uses = 8;
   */
  maxUses: number;

  /**
   * Сколько раз использована.
   *
   * @generated from field: int32 uses = 9;
   */
  uses: number;

  /**
   * Вход только через лобби (одобрение ADMIN/OWNER).
   *
   * @generated from field: bool requires_lobby = 10;
   */
  requiresLobby: boolean;

  /**
   * Можно войти без аккаунта, гостем (`Capabilities.guests`). **Работает для `ROOM_JOIN`**: внешнего
   * зовут на встречу — эпизод с началом и концом. Для `CHAT_INVITE`/`CHANNEL_INVITE` в v1 узел
   * отказывает (`CAPABILITY_DISABLED`): гость в чате получил бы всю переписку, а политики
   * подтверждения телефона из ADR-004 ещё нет, и ссылка «можно без учётной записи», по которой
   * никто не войдёт, — обещание, молчащее у заказчика в руках.
   *
   * @generated from field: bool allows_guests = 11;
   */
  allowsGuests: boolean;

  /**
   * Когда отозвана; пусто — действует.
   *
   * @generated from field: google.protobuf.Timestamp revoked_at = 12;
   */
  revokedAt?: Timestamp | undefined;
};

/**
 * Describes the message yofis.v1.Link.
 * Use `create(LinkSchema)` to create a new message.
 */
export const LinkSchema: GenMessage<Link> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 0);

/**
 * Выпуск ссылки.
 *
 * @generated from message yofis.v1.CreateLinkRequest
 */
export type CreateLinkRequest = Message<"yofis.v1.CreateLinkRequest"> & {
  /**
   * Область действия (кроме USER_INVITE и PASSWORD_RESET).
   *
   * @generated from field: yofis.v1.LinkScope scope = 1;
   */
  scope: LinkScope;

  /**
   * Цель: идентификатор чата, комнаты или файла.
   *
   * @generated from field: string target_id = 2;
   */
  targetId: string;

  /**
   * Срок действия; пусто — по умолчанию узла (7 дней).
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * Лимит использований; 0 — без лимита.
   *
   * @generated from field: int32 max_uses = 4;
   */
  maxUses: number;

  /**
   * Требовать лобби.
   *
   * @generated from field: bool requires_lobby = 5;
   */
  requiresLobby: boolean;

  /**
   * Разрешить внешних участников без учётной записи. Только с `ROOM_JOIN`; с `CHAT_INVITE`
   * и `CHANNEL_INVITE` — `CAPABILITY_DISABLED` (см. `Link.allows_guests`).
   *
   * @generated from field: bool allows_guests = 6;
   */
  allowsGuests: boolean;

  /**
   * Ключ идемпотентности (UUIDv7).
   *
   * @generated from field: string idempotency_key = 7;
   */
  idempotencyKey: string;
};

/**
 * Describes the message yofis.v1.CreateLinkRequest.
 * Use `create(CreateLinkRequestSchema)` to create a new message.
 */
export const CreateLinkRequestSchema: GenMessage<CreateLinkRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 1);

/**
 * Ответ на выпуск ссылки.
 *
 * @generated from message yofis.v1.CreateLinkResponse
 */
export type CreateLinkResponse = Message<"yofis.v1.CreateLinkResponse"> & {
  /**
   * Ссылка.
   *
   * @generated from field: yofis.v1.Link link = 1;
   */
  link?: Link | undefined;
};

/**
 * Describes the message yofis.v1.CreateLinkResponse.
 * Use `create(CreateLinkResponseSchema)` to create a new message.
 */
export const CreateLinkResponseSchema: GenMessage<CreateLinkResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 2);

/**
 * Запрос ссылок цели.
 *
 * @generated from message yofis.v1.ListLinksRequest
 */
export type ListLinksRequest = Message<"yofis.v1.ListLinksRequest"> & {
  /**
   * Идентификатор чата, комнаты или файла; пусто — приглашения узла (только администратору).
   * Ссылки встречи видит тот, кто её начал, и администратор узла: у встречи нет ролей чата.
   *
   * @generated from field: string target_id = 1;
   */
  targetId: string;
};

/**
 * Describes the message yofis.v1.ListLinksRequest.
 * Use `create(ListLinksRequestSchema)` to create a new message.
 */
export const ListLinksRequestSchema: GenMessage<ListLinksRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 3);

/**
 * Ответ со ссылками.
 *
 * @generated from message yofis.v1.ListLinksResponse
 */
export type ListLinksResponse = Message<"yofis.v1.ListLinksResponse"> & {
  /**
   * Ссылки, от новых к старым.
   *
   * @generated from field: repeated yofis.v1.Link links = 1;
   */
  links: Link[];
};

/**
 * Describes the message yofis.v1.ListLinksResponse.
 * Use `create(ListLinksResponseSchema)` to create a new message.
 */
export const ListLinksResponseSchema: GenMessage<ListLinksResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 4);

/**
 * Отзыв ссылки.
 *
 * @generated from message yofis.v1.RevokeLinkRequest
 */
export type RevokeLinkRequest = Message<"yofis.v1.RevokeLinkRequest"> & {
  /**
   * Токен ссылки.
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message yofis.v1.RevokeLinkRequest.
 * Use `create(RevokeLinkRequestSchema)` to create a new message.
 */
export const RevokeLinkRequestSchema: GenMessage<RevokeLinkRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 5);

/**
 * Ответ на отзыв; полей нет.
 *
 * @generated from message yofis.v1.RevokeLinkResponse
 */
export type RevokeLinkResponse = Message<"yofis.v1.RevokeLinkResponse"> & {
};

/**
 * Describes the message yofis.v1.RevokeLinkResponse.
 * Use `create(RevokeLinkResponseSchema)` to create a new message.
 */
export const RevokeLinkResponseSchema: GenMessage<RevokeLinkResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 6);

/**
 * Разрешение ссылки.
 *
 * @generated from message yofis.v1.ResolveLinkRequest
 */
export type ResolveLinkRequest = Message<"yofis.v1.ResolveLinkRequest"> & {
  /**
   * Токен ссылки.
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message yofis.v1.ResolveLinkRequest.
 * Use `create(ResolveLinkRequestSchema)` to create a new message.
 */
export const ResolveLinkRequestSchema: GenMessage<ResolveLinkRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 7);

/**
 * Ответ на разрешение ссылки.
 *
 * @generated from message yofis.v1.ResolveLinkResponse
 */
export type ResolveLinkResponse = Message<"yofis.v1.ResolveLinkResponse"> & {
  /**
   * Что за ссылкой.
   *
   * @generated from field: yofis.v1.LinkPreview preview = 1;
   */
  preview?: LinkPreview | undefined;
};

/**
 * Describes the message yofis.v1.ResolveLinkResponse.
 * Use `create(ResolveLinkResponseSchema)` to create a new message.
 */
export const ResolveLinkResponseSchema: GenMessage<ResolveLinkResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 8);

/**
 * Публичное описание того, что за ссылкой (без токена и без списка участников).
 *
 * @generated from message yofis.v1.LinkPreview
 */
export type LinkPreview = Message<"yofis.v1.LinkPreview"> & {
  /**
   * Область действия.
   *
   * @generated from field: yofis.v1.LinkScope scope = 1;
   */
  scope: LinkScope;

  /**
   * Название чата/комнаты/файла или имя приглашающего.
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * Аватар цели; пусто — нет.
   *
   * @generated from field: string avatar_file_id = 3;
   */
  avatarFileId: string;

  /**
   * Домен узла, на котором цель.
   *
   * @generated from field: string node_domain = 4;
   */
  nodeDomain: string;

  /**
   * Число участников (для чатов и комнат).
   *
   * @generated from field: int32 member_count = 5;
   */
  memberCount: number;

  /**
   * Вход через лобби.
   *
   * @generated from field: bool requires_lobby = 6;
   */
  requiresLobby: boolean;

  /**
   * Можно войти гостем: у ссылки разрешены внешние участники **и** узел их принимает.
   *
   * @generated from field: bool allows_guests = 7;
   */
  allowsGuests: boolean;

  /**
   * Нужен аккаунт на узле (гостей нет или выключены).
   *
   * @generated from field: bool requires_account = 8;
   */
  requiresAccount: boolean;

  /**
   * Ссылка истекла, отозвана или исчерпана — вход невозможен.
   *
   * Производное от `reason`: истинно, когда причина непуста. Оставлено для клиентов до 0.18; новые
   * смотрят `reason` — по одному булеву полю правильный экран не выбрать.
   *
   * @generated from field: bool expired = 9;
   */
  expired: boolean;

  /**
   * Почему ссылка не работает: `LINK_EXPIRED`, `LINK_REVOKED`, `LINK_EXHAUSTED`, `GUESTS_DISABLED`
   * (0.18). Пусто — ссылка рабочая.
   *
   * Одно булево поле на три случая приглашало ошибиться, и клиент ошибался: показывал «срок истёк»
   * на ссылке, которой уже воспользовались. Разница не косметическая — кому сказали «истёк срок»,
   * пойдёт просить новую, а кому сказали «уже использована», спросит, КТО вошёл по его ссылке. Для
   * предъявительской ссылки это, возможно, единственный момент, когда чужой вход вообще заметят.
   *
   * @generated from field: yofis.v1.ErrorReason reason = 10;
   */
  reason: ErrorReason;
};

/**
 * Describes the message yofis.v1.LinkPreview.
 * Use `create(LinkPreviewSchema)` to create a new message.
 */
export const LinkPreviewSchema: GenMessage<LinkPreview> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 9);

/**
 * Вход по ссылке.
 *
 * @generated from message yofis.v1.JoinByLinkRequest
 */
export type JoinByLinkRequest = Message<"yofis.v1.JoinByLinkRequest"> & {
  /**
   * Токен ссылки.
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message yofis.v1.JoinByLinkRequest.
 * Use `create(JoinByLinkRequestSchema)` to create a new message.
 */
export const JoinByLinkRequestSchema: GenMessage<JoinByLinkRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 10);

/**
 * Ответ на вход по ссылке.
 *
 * @generated from message yofis.v1.JoinByLinkResponse
 */
export type JoinByLinkResponse = Message<"yofis.v1.JoinByLinkResponse"> & {
  /**
   * Чат, куда вошёл; пусто для встречи и если заявка в лобби.
   *
   * @generated from field: yofis.v1.Chat chat = 1;
   */
  chat?: Chat | undefined;

  /**
   * Заявка в лобби ожидает решения; результат придёт событием `LobbyUpdated`.
   *
   * @generated from field: bool lobby_pending = 2;
   */
  lobbyPending: boolean;

  /**
   * Встреча, куда вошёл (`LINK_SCOPE_ROOM_JOIN`); пусто для чата и если заявка в лобби (0.17).
   * Отдельным полем, а не в `chat`: у встречи нет ни ленты, ни участников чата, и подменять
   * одно другим значило бы отдавать клиенту объект, половина полей которого — неправда.
   *
   * @generated from field: yofis.v1.Room room = 3;
   */
  room?: Room | undefined;
};

/**
 * Describes the message yofis.v1.JoinByLinkResponse.
 * Use `create(JoinByLinkResponseSchema)` to create a new message.
 */
export const JoinByLinkResponseSchema: GenMessage<JoinByLinkResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 11);

/**
 * Запрос заявок в лобби.
 *
 * @generated from message yofis.v1.ListLobbyRequest
 */
export type ListLobbyRequest = Message<"yofis.v1.ListLobbyRequest"> & {
  /**
   * Идентификатор чата или комнаты.
   *
   * @generated from field: string target_id = 1;
   */
  targetId: string;

  /**
   * Курсор страницы.
   *
   * @generated from field: string cursor = 2;
   */
  cursor: string;

  /**
   * Размер страницы; по умолчанию 50, максимум 200.
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message yofis.v1.ListLobbyRequest.
 * Use `create(ListLobbyRequestSchema)` to create a new message.
 */
export const ListLobbyRequestSchema: GenMessage<ListLobbyRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 12);

/**
 * Ответ с заявками.
 *
 * @generated from message yofis.v1.ListLobbyResponse
 */
export type ListLobbyResponse = Message<"yofis.v1.ListLobbyResponse"> & {
  /**
   * Заявки, от старых к новым.
   *
   * @generated from field: repeated yofis.v1.LobbyEntry entries = 1;
   */
  entries: LobbyEntry[];

  /**
   * Пагинация.
   *
   * @generated from field: yofis.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message yofis.v1.ListLobbyResponse.
 * Use `create(ListLobbyResponseSchema)` to create a new message.
 */
export const ListLobbyResponseSchema: GenMessage<ListLobbyResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 13);

/**
 * Заявка в лобби.
 *
 * @generated from message yofis.v1.LobbyEntry
 */
export type LobbyEntry = Message<"yofis.v1.LobbyEntry"> & {
  /**
   * Кто просится.
   *
   * @generated from field: yofis.v1.User user = 1;
   */
  user?: User | undefined;

  /**
   * Когда.
   *
   * @generated from field: google.protobuf.Timestamp requested_at = 2;
   */
  requestedAt?: Timestamp | undefined;
};

/**
 * Describes the message yofis.v1.LobbyEntry.
 * Use `create(LobbyEntrySchema)` to create a new message.
 */
export const LobbyEntrySchema: GenMessage<LobbyEntry> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 14);

/**
 * Впустить из лобби.
 *
 * @generated from message yofis.v1.AdmitLobbyRequest
 */
export type AdmitLobbyRequest = Message<"yofis.v1.AdmitLobbyRequest"> & {
  /**
   * Идентификатор чата или комнаты.
   *
   * @generated from field: string target_id = 1;
   */
  targetId: string;

  /**
   * Адрес пользователя.
   *
   * @generated from field: string address = 2;
   */
  address: string;
};

/**
 * Describes the message yofis.v1.AdmitLobbyRequest.
 * Use `create(AdmitLobbyRequestSchema)` to create a new message.
 */
export const AdmitLobbyRequestSchema: GenMessage<AdmitLobbyRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 15);

/**
 * Ответ на впуск; полей нет.
 *
 * @generated from message yofis.v1.AdmitLobbyResponse
 */
export type AdmitLobbyResponse = Message<"yofis.v1.AdmitLobbyResponse"> & {
};

/**
 * Describes the message yofis.v1.AdmitLobbyResponse.
 * Use `create(AdmitLobbyResponseSchema)` to create a new message.
 */
export const AdmitLobbyResponseSchema: GenMessage<AdmitLobbyResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 16);

/**
 * Отклонить заявку.
 *
 * @generated from message yofis.v1.RejectLobbyRequest
 */
export type RejectLobbyRequest = Message<"yofis.v1.RejectLobbyRequest"> & {
  /**
   * Идентификатор чата или комнаты.
   *
   * @generated from field: string target_id = 1;
   */
  targetId: string;

  /**
   * Адрес пользователя.
   *
   * @generated from field: string address = 2;
   */
  address: string;
};

/**
 * Describes the message yofis.v1.RejectLobbyRequest.
 * Use `create(RejectLobbyRequestSchema)` to create a new message.
 */
export const RejectLobbyRequestSchema: GenMessage<RejectLobbyRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 17);

/**
 * Ответ на отклонение; полей нет.
 *
 * @generated from message yofis.v1.RejectLobbyResponse
 */
export type RejectLobbyResponse = Message<"yofis.v1.RejectLobbyResponse"> & {
};

/**
 * Describes the message yofis.v1.RejectLobbyResponse.
 * Use `create(RejectLobbyResponseSchema)` to create a new message.
 */
export const RejectLobbyResponseSchema: GenMessage<RejectLobbyResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_link, 18);

/**
 * Область действия ссылки-права.
 *
 * @generated from enum yofis.v1.LinkScope
 */
export enum LinkScope {
  /**
   * Не задана.
   *
   * @generated from enum value: LINK_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Приглашение в группу.
   *
   * @generated from enum value: LINK_SCOPE_CHAT_INVITE = 1;
   */
  CHAT_INVITE = 1,

  /**
   * Приглашение в канал.
   *
   * @generated from enum value: LINK_SCOPE_CHANNEL_INVITE = 2;
   */
  CHANNEL_INVITE = 2,

  /**
   * Приглашение сотрудника на узел (выпускает администратор; `AuthService.RegisterByInvite`).
   *
   * @generated from enum value: LINK_SCOPE_USER_INVITE = 3;
   */
  USER_INVITE = 3,

  /**
   * Вход в комнату встречи: по ней входят и сотрудники, и внешние участники (`allows_guests`).
   *
   * @generated from enum value: LINK_SCOPE_ROOM_JOIN = 4;
   */
  ROOM_JOIN = 4,

  /**
   * Доступ к файлу.
   *
   * @generated from enum value: LINK_SCOPE_FILE_SHARE = 5;
   */
  FILE_SHARE = 5,

  /**
   * Одноразовая смена пароля: выпускает `AdminService.ResetPassword`, принимает `AuthService.CompletePasswordReset` (0.4).
   *
   * @generated from enum value: LINK_SCOPE_PASSWORD_RESET = 6;
   */
  PASSWORD_RESET = 6,

  /**
   * Вход существующего сотрудника по ссылке, без пароля (0.15, ADR-036). Отличается от `USER_INVITE`
   * намеренно: «завести учётную запись» и «войти в существующую» — разные действия и в политике,
   * и в журнале аудита, а один токен, означающий то или другое по состоянию учётки, даёт
   * неразличимый аудит и ошибки в правах.
   *
   * @generated from enum value: LINK_SCOPE_LOGIN = 7;
   */
  LOGIN = 7,
}

/**
 * Describes the enum yofis.v1.LinkScope.
 */
export const LinkScopeSchema: GenEnum<LinkScope> = /*@__PURE__*/
  enumDesc(file_yofis_v1_link, 0);

/**
 * Выпуск, разрешение и использование ссылок-прав; лобби.
 *
 * @generated from service yofis.v1.LinkService
 */
export const LinkService: GenService<{
  /**
   * Выпустить ссылку. Права: ADMIN/OWNER чата (CHAT_INVITE, CHANNEL_INVITE), владелец файла (FILE_SHARE),
   * участник встречи (ROOM_JOIN — зовёт тот, кто в ней, а не тот, кто узнал её идентификатор).
   * `USER_INVITE` выпускает только `AdminService.CreateUserInvite`.
   * Уровень: signed. Ошибки: ROLE_REQUIRED, IDEMPOTENCY_CONFLICT.
   *
   * @generated from rpc yofis.v1.LinkService.CreateLink
   */
  createLink: {
    methodKind: "unary";
    input: typeof CreateLinkRequestSchema;
    output: typeof CreateLinkResponseSchema;
  },
  /**
   * Ссылки цели (чата, встречи, файла), включая отозванные и истёкшие.
   * Уровень: signed. Ошибки: ROLE_REQUIRED.
   *
   * @generated from rpc yofis.v1.LinkService.ListLinks
   */
  listLinks: {
    methodKind: "unary";
    input: typeof ListLinksRequestSchema;
    output: typeof ListLinksResponseSchema;
  },
  /**
   * Отозвать ссылку; уже вошедшие остаются.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.LinkService.RevokeLink
   */
  revokeLink: {
    methodKind: "unary";
    input: typeof RevokeLinkRequestSchema;
    output: typeof RevokeLinkResponseSchema;
  },
  /**
   * Что за ссылкой — для экрана «вас приглашают в …» и лёгкого режима; без аккаунта.
   * Уровень: public. Ошибки: not_found (нет такой ссылки).
   *
   * @generated from rpc yofis.v1.LinkService.ResolveLink
   */
  resolveLink: {
    methodKind: "unary";
    input: typeof ResolveLinkRequestSchema;
    output: typeof ResolveLinkResponseSchema;
  },
  /**
   * Войти по ссылке: в чат/канал/комнату или в лобби. Гость — тоже session (после `JoinAsGuest`).
   * Уровень: session. Ошибки: LINK_EXPIRED, LINK_REVOKED, LINK_EXHAUSTED, LOBBY_PENDING, GUESTS_DISABLED.
   *
   * @generated from rpc yofis.v1.LinkService.JoinByLink
   */
  joinByLink: {
    methodKind: "unary";
    input: typeof JoinByLinkRequestSchema;
    output: typeof JoinByLinkResponseSchema;
  },
  /**
   * Заявки в лобби цели (для ADMIN/OWNER).
   * Уровень: signed. Ошибки: ROLE_REQUIRED.
   *
   * @generated from rpc yofis.v1.LinkService.ListLobby
   */
  listLobby: {
    methodKind: "unary";
    input: typeof ListLobbyRequestSchema;
    output: typeof ListLobbyResponseSchema;
  },
  /**
   * Впустить из лобби: пользователь становится участником и получает `ChatUpdated`.
   * Уровень: signed. Ошибки: ROLE_REQUIRED.
   *
   * @generated from rpc yofis.v1.LinkService.AdmitLobby
   */
  admitLobby: {
    methodKind: "unary";
    input: typeof AdmitLobbyRequestSchema;
    output: typeof AdmitLobbyResponseSchema;
  },
  /**
   * Отклонить заявку из лобби; пользователь получает `LobbyUpdated(REJECTED)`.
   * Уровень: signed. Ошибки: ROLE_REQUIRED.
   *
   * @generated from rpc yofis.v1.LinkService.RejectLobby
   */
  rejectLobby: {
    methodKind: "unary";
    input: typeof RejectLobbyRequestSchema;
    output: typeof RejectLobbyResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yofis_v1_link, 0);

